import React, { Component } from "react";
import ModalComponent from "../../components/UI/Modal/Modal";
import DynamicFormBuilder from "../../components/DynamicFormBuilder/DynamicFormBuilder";
import getAllRequests from "../../api/formsApi/getAllRequests";
import getAttachments from "../../api/formsApi/getAttachments";
import getStatus from "../../api/formsApi/getStatus";
import changeRequestStatus from "../../api/formsApi/changeRequestStatus";
import TableComponent from "../../components/UI/TableComponent/TableComponent";
import oibValidation from "../../helperFunctions/oibValidation/oibValidation";
import { DOCUMENT_UUID } from "../../constants/constants";
import { connect } from "react-redux";
import InputComponent from "../../components/UI/InputComponent/InputComponent";
import axiosInstance from "../../api/utils/axiosInstance";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";
import moment from "moment";
import SearchComponent from "../../components/UI/SearchComponent/SearchComponent";
import Spinner from "../../components/UI/Spinner/Spinner";
import { toast } from "react-toastify";
import DatepickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import { Pagination } from "antd";

class OdobrenjeZahtjeva extends Component {
  state = {
    isLoading: false,
    dataFetched: false,
    formListData: [],
    countryList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    modal: false,
    zahtjevId: "",
    requestsLoaded: false,
    zahtjevAtrId: null,
    initialFormData: [],
    dateModal: false,
    dropDownData: [],
    readOnly: true,
    modalTitle: "",
    attachments: [],
    btnClicked: null,
    invalidOib: false,
    error: false,
    datIzvrsnosti: "",
    datPravomocnosti: "",
    secondaryOib: {
      invalidOib: false,
      value: "",
    },
    searchData: {
      searchText: "",
      status: "",
      formName: "",
      initialItemCount: 1,
    },
    formClassData: {
      klasa: "",
      urBroj: "",
    },
    requestType: [
      {
        formId: 1,
        formDescription: "REGISTAR OVLAŠTENIH REVIZORA",
      },
      { formId: 3, formDescription: "REGISTAR REVIZORSKIH DRUŠTAVA" },
      {
        formId: 4,
        formDescription: "REGISTAR SAMOSTALNIH REVIZORA",
      },
      {
        formId: 5,
        formDescription:
          "REGISTAR OVLAŠTENIH REVIZORA IZ DRUGIH DRŽAVA ČLANICA",
      },
      {
        formId: 6,
        formDescription:
          "REGISTAR REVIZORSKIH DRUŠTAVA IZ DRUGIH DRŽAVA ČLANICA",
      },
      {
        formId: 7,
        formDescription: "REGISTAR OVLAŠTENIH REVIZORA IZ TREĆIH ZEMALJA",
      },
      {
        formId: 8,
        formDescription:
          "REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I REGISTAR REVIZORA U TREĆOJ ZEMLJI",
      },
      {
        formId: 10,
        formDescription: "REGISTAR REVIZORSKIH VJEŽBENIKA",
      },
    ],
    test: "",
    classModal: false,
  };

  componentDidMount = () => {
    this.getInitialData();
  };

  getInitialData = async () => {
    try {
      let fetchStatuses = await getStatus("/sifarnici/statuses");
      let fetchStatusesData = fetchStatuses.data;
      this.setState({
        dropDownData: fetchStatusesData,
      });
    } catch (e) {
      throw e;
    }
  };

  setInitialFormData = (data) => {
    this.setState(
      {
        initialFormData: data,
        modalTitle: data.formDescription,
        formClassData: {
          urBroj: data.urBroj || "",
          klasa: data.klasa || "",
        },
      },
      () => {
        this.getCountryList();
      }
    );
  };

  fetchForms = async (url) => {
    const res = await fetchFormsApi(url);
    const { data } = res;
    this.setInitialFormData(data);
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCityAndMuncipalityList();
      }
    );
  };

  getCityAndMuncipalityList = async () => {
    const gradExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find((grad) => grad.controlLabel === "Naziv grada")
    );
    // .map(el => el)
    if (gradExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/gradOpcina`);
      this.setState(
        {
          cityAndMuncipalityList: data,
        },
        () => {
          this.getDistrictList();
        }
      );
    } else {
      this.getDistrictList();
    }
  };

  getDistrictList = async () => {
    const naseljeExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find(
        (naselje) => naselje.controlLabel === "Naziv mjesta"
      )
    );
    // .find(naselje => naselje.controlLabel === "Naziv naselja");

    if (naseljeExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/naselja`);
      this.setState({ districtList: data, requestsLoaded: true });
    } else {
      this.setState({
        requestsLoaded: true,
      });
    }
  };

  openModal = (id, zahtjevAtrId, e) => {
    e.persist();
    let buttonId = e.target.id;
    this.fetchAttachments(id, zahtjevAtrId, buttonId);
  };

  setUserInputState = (userInputObj, isOib, value) => {
    this.setState(userInputObj, () => {
      isOib && this.validateOib(value);
    });
  };

  validateOib = (oib) => {
    let checkOibValidity = oibValidation(oib);
    oib &&
      !checkOibValidity &&
      this.setState({
        invalidOib: !checkOibValidity,
      });
  };

  fetchAttachments = async (id, zahtjevAtrId, buttonId) => {
    try {
      let res = await getAttachments("/attachments", id);
      const { data } = res;
      this.setState(
        {
          modal: true,
          requestsLoaded: false,
          initialFormData: [],
          modalTitle: "",
          zahtjevId: id,
          zahtjevAtrId: zahtjevAtrId,
          attachments: data.sort((a, b) => a.controlIndex - b.controlIndex),
          readOnly: buttonId == "btnUnos" ? false : true,
          btnClicked: buttonId,
        },
        () => {
          this.fetchForms(`request/${zahtjevAtrId}?isEdit=${false}`);
        }
      );
    } catch (e) {
      throw e;
    }
  };

  solutionsHandler = (e, uuid, zahtjevAtrId, formId, status) => {
    this.props.dispatchUuid(uuid, zahtjevAtrId, formId);
    this.props.history.push(
      `/kreiranje-rjesenja/obrazac/${e.currentTarget.value}`,
      {
        status,
      }
    );
  };

  hideModal = () => {
    this.setState({
      modal: false,
      readOnly: true,
    });
  };

  dropDownHandler = (e) => {
    let { value } = e.target;
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        status: value,
      },
    }));
  };

  openClassModal = (e) => {
    e.preventDefault();

    this.setState({
      classModal: true,
    });
  };

  statusChangeHandler = (e) => {
    e.preventDefault()
    this.setState({ isLoading: true }, () => {
      const { klasa, urBroj } = this.state.formClassData;
      const { datIzvrsnosti, datPravomocnosti } = this.state;
      if (!klasa || !urBroj) {
        this.setState({ error: true });
        this.props.formSubmitError(true, "Popunite obavezna polja!");
        this.setState({ isLoading: false });
        return;
      }
      const formData = { ...this.state.initialFormData };
      const uuid = formData.zahtjevId;
      const zahtjevAtrId = formData.zahtjevAtrId;
      this.props.formSubmitSuccess(true, "Zahtjev je uspješno preuzet!");
      this.changeStatus(uuid, zahtjevAtrId, formData);
    });
  };

  changeStatus = async (uuid, zahtjevAtrId) => {
    try {
      const res = await changeRequestStatus(
        `/requests/take/${zahtjevAtrId}?klasa=${this.state.formClassData.klasa}&urBroj=${this.state.formClassData.urBroj}`
      );

      const { data } = res;

      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: false,
          error: false,
          formClassData: {
            klasa: "",
            urBroj: "",
          },
          classModal: false,
          formListData: [
            ...prevState.formListData.map((element) => {
              return element.zahtjevId === uuid
                ? {
                    ...element,
                    status: data.status,
                    zahtjevAtrId: data.zahtjevAtrId,
                  }
                : element;
            }),
          ],
        }),
        () => {
          this.refreshStatuses();
        }
      );
    } catch (e) {
      throw e;
    }
  };

  refreshStatuses = async () => {
    const res = await axiosInstance(
      `/search/request?formId=${this.state.searchData.formName}&status=${this.state.searchData.status}&pojam=${this.state.searchData.searchText}&page=1&offset=10`
    );
    const { data } = res;
    this.setState({
      formListData: data.result,
      dataFetched: true,
      classModal: false,
      modal: false,
      searchData: {
        ...this.state.searchData,
        initialItemCount: res.data.size,
      },
    });
  };

  redirectToEntryForm = (e, element) => {
    const zahtjevAtrId = element.zahtjevAtrId;
    const formId = element.formId;

    const { formListData } = this.state;
    let findFormIds = formListData.find(
      (item) => item.zahtjevAtrId == zahtjevAtrId
    );

    this.props.dispatchUuid(findFormIds.zahtjevId, zahtjevAtrId, formId);

    switch (formId) {
      case 1:
        this.props.history.push(
          "/unos-u-registar/registar-ovlastenih-revizora"
        );
        break;
      case 2:
        this.props.history.push(
          "/unos-u-registar/registar-revizorskih-drustava"
        );
        break;
      case 3:
        this.props.history.push(
          "/unos-u-registar/registar-revizorskih-drustava"
        );
        break;
      case 4:
        this.props.history.push(
          "/unos-u-registar/registar-samostalnih-revizora"
        );
        break;
      case 5:
        this.props.history.push(
          "/unos-u-registar/registar-ovlastenih-revizora-iz-drugih-drzava-clanica"
        );
        break;
      case 6:
        this.props.history.push(
          "/unos-u-registar/registar-revizorskih-drustava-iz-drugih-drzava-clanica"
        );
        break;
      case 7:
        this.props.history.push(
          "/unos-u-registar/registar-ovlastenih-revizora-iz-trecih-zemalja"
        );
        break;
      case 8:
        this.props.history.push(
          "/unos-u-registar/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji"
        );
        break;
      case 10:
        this.props.history.push(
          "/unos-u-registar/registar-revizorskih-vjezbenika"
        );
        break;
      default:
        break;
    }
  };

  userInputHandler = (e) => {
    e.persist();
    this.setState((prevState) => ({
      formClassData: {
        ...prevState.formClassData,
        [e.target.id]: e.target.value,
      },
    }));
  };

  searchInputHandler = (e) => {
    e.persist();
    const searchText = e.target.id;
    const inputValue = e.target.value;

    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        [searchText]: inputValue,
      },
    }));
  };

  statusDropdownHandler = (e) => {
    if (e.target.value === "SVI STATUSI") {
      this.setState((prevState) => ({
        searchData: {
          ...prevState.searchData,
          status: "",
        },
      }));
      return;
    }
    e.persist();
    const status = e.target.value;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        status,
      },
    }));
  };

  valueDropdownHandler = (e) => {
    if (e.target.value === "SVI REGISTRI") {
      this.setState((prevState) => ({
        searchData: {
          ...prevState.searchData,
          formName: "",
        },
      }));
      return;
    }
    e.persist();
    const formName = e.target.value;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        formName,
      },
    }));
  };

  submitHandler = async (e) => {
    e.preventDefault();
    const res = await axiosInstance(
      `/search/request?formId=${this.state.searchData.formName}&status=${this.state.searchData.status}&pojam=${this.state.searchData.searchText}&page=1&offset=10`
    );
    const { data } = res;
    this.setState({
      formListData: data.result,
      dataFetched: true,
      searchData: {
        ...this.state.searchData,
        initialItemCount: res.data.size,
      },
    });
    const { formListData } = this.state;
    if (formListData.length < 1) {
      this.setState({ error: true });
      this.props.formSubmitError(true, "Za navedene parametre nema podataka.");

      return;
    }
  };

  datePickerHandler = (date, dateString, objData) => {
    const selectedDate = dateString;
    this.setState({
      [objData.id]: selectedDate,
    });
  };

  onPageChanged = (page, pageSize) => {
    let url = `/search/request?formId=${this.state.searchData.formName}
    &status=${this.state.searchData.status}&pojam=${
      this.state.searchData.searchText
    }&&page=${page}&offset=${10}`;

    axiosInstance.get(url).then((res) => {
      this.setState({ formListData: res.data.result });
    });
  };

  hideClassModal = () => {
    this.setState({
      classModal: false,
      formClassData: {
        klasa: "",
        urBroj: "",
      },
    });
  };

  showDateModal = (zahtjevAtrId) => async (e) => {
    e.preventDefault();

    const { data } = await axiosInstance.get(
      `/request/${zahtjevAtrId}/dat-izvrsnosti-pravomocnosti`
    );

    this.setState({
      zahtjevAtrId,
      dateModal: true,
      datIzvrsnosti: data.datumIzvrsnosti || "",
      datPravomocnosti: data.datumPravomocnosti || "",
    });
  };

  hideDateModal = () => {
    this.setState({
      dateModal: false,
    });
  };

  dateChangeHandler = async (e) => {
    e.preventDefault();
    const { datIzvrsnosti, datPravomocnosti, zahtjevAtrId } = this.state;

    if (datIzvrsnosti.length < 1 && datPravomocnosti.length < 1) {
      toast.info("Unesite barem jedan datum!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    try {
      const submitData = {
        zahtjevAtrId: zahtjevAtrId,
        datumIzvrsnosti: datIzvrsnosti,
        datumPravomocnosti: datPravomocnosti,
      };

      await axiosInstance.patch(
        "/request/edit/datum-izvrsnosti-pravomocnosti",
        submitData
      );

      toast.success("Datumi su uspješno ažurirani!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      this.hideDateModal();
    } catch (e) {
      toast.info("Nešto je pošlo po krivu", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  render() {
    let parentState = { ...this.state };
    let headers = [
      "Naziv zahtjeva",
      "Ime i prezime / naziv subjekta",
      "Datum podnošenja",
      "Pregled",
      "Kreiraj izlazni dokument/akt",
      "Datum izvršnosti / pravomoćnosti",
      "Unos u registar",
      "Status",
    ];

    let statusOptions = parentState.dropDownData.map((element) => (
      <option key={element.id} value={element.id}>
        {element.value}
      </option>
    ));

    let formOptions = parentState.requestType.map((element) => (
      <option key={element.formId} value={element.formId}>
        {element.formDescription}
      </option>
    ));

    return (
      <>
        <SearchComponent
          dropdownLabel={"Odaberite registar"}
          onSubmit={this.submitHandler}
          searchHandler={this.searchInputHandler}
          searchValue={this.state.searchData.searchText}
          statusDropdownHandler={this.statusDropdownHandler}
          dropdownValue={this.state.searchData.status}
          statusOptions={statusOptions}
          valueDropdownHandler={this.valueDropdownHandler}
          formOptions={formOptions}
          text={"SVI REGISTRI"}
        />
        {this.state.formListData && this.state.formListData.length > 0 && (
          <React.Fragment>
            <TableComponent
              redirectToEntryForm={this.redirectToEntryForm}
              headers={headers}
              parentState={parentState}
              openModal={this.openModal}
              solutionsHandler={this.solutionsHandler}
              showDateModal={this.showDateModal}
            />
            {this.state.searchData.initialItemCount &&
            this.state.searchData.initialItemCount > 0 ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <Pagination
                  defaultCurrent={1}
                  defaultPageSize={10}
                  total={this.state.searchData.initialItemCount}
                  responsive
                  onChange={this.onPageChanged}
                  showSizeChanger={false}
                />
              </div>
            ) : null}
            <ModalComponent
              size="xl"
              show={this.state.modal}
              onHide={this.hideModal}
              title={this.state.modalTitle}
            >
              {this.state.requestsLoaded ? (
                <DynamicFormBuilder
                  url={`request/${this.state.zahtjevAtrId}?isEdit=${false}`}
                  parentState={parentState}
                  hideModal={this.hideModal}
                  dropDownHandler={this.dropDownHandler}
                  statusChangeHandler={this.statusChangeHandler}
                  setUserInputState={this.setUserInputState}
                  openClassModal={this.openClassModal}
                />
              ) : (
                <Spinner />
              )}
            </ModalComponent>
            <ModalComponent
              title="Unesite klasu i urudžbeni broj!"
              size="sm"
              show={this.state.classModal}
              onHide={this.hideClassModal}
            >
              <form onSubmit={this.statusChangeHandler}>
                <label>Klasa* </label>
                <InputComponent
                  style={
                    this.state.error &&
                    this.state.formClassData.klasa.length < 1 &&
                    "red"
                  }
                  onChange={this.userInputHandler}
                  value={this.state.formClassData.klasa}
                  id="klasa"
                  placeholder="Klasa"
                />

                <label>Urudžbeni broj* </label>
                <InputComponent
                  style={
                    this.state.error &&
                    this.state.formClassData.urBroj.length < 1 &&
                    "red"
                  }
                  id="urBroj"
                  onChange={this.userInputHandler}
                  value={this.state.formClassData.urBroj}
                  placeholder="Urudžbeni broj"
                />
                <br></br>
                <br></br>
                <div className="row">
                  <div className="col">
                    <ButtonComponent
                      loading={this.state.isLoading}
                      type="submit"
                      block
                    >
                      Unos
                    </ButtonComponent>
                  </div>
                  <div className="col">
                    <ButtonComponent
                      onClick={this.hideClassModal}
                      block
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </form>
            </ModalComponent>

            <ModalComponent
              title="Unesite datum izvršnosti i pravomoćnosti!"
              size="sm"
              show={this.state.dateModal}
              onHide={this.hideDateModal}
              animation={true}
            >
              <form onSubmit={this.dateChangeHandler}>
                <div className="datepicker-modal">
                  <DatepickerComponent
                    handleDayClick={this.datePickerHandler}
                    controlLabel={"Datum izvršnosti"}
                    value={this.state.datIzvrsnosti}
                    index={{ id: "datIzvrsnosti" }}
                    width={"100%"}
                  />
                  <DatepickerComponent
                    handleDayClick={this.datePickerHandler}
                    controlLabel={"Datum pravomoćnosti"}
                    value={this.state.datPravomocnosti}
                    index={{ id: "datPravomocnosti" }}
                    width={"100%"}
                  />
                </div>

                <div className="row">
                  <div className="col">
                    <ButtonComponent type="submit" block>
                      Unos
                    </ButtonComponent>
                  </div>
                  <div className="col">
                    <ButtonComponent
                      onClick={this.hideDateModal}
                      block
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </form>
            </ModalComponent>
          </React.Fragment>
        )}
        {/* {this.state.formListData.length === 0 && this.state.dataFetched && (
          <p style={{ textAlign: "center", marginTop: "32px" }}>
            Nema rezultata pretrage
          </p>
        )} */}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUuid: (uuid, zahtjevAtrId, formId) =>
      dispatch({
        type: DOCUMENT_UUID,
        uuid: uuid,
        zahtjevAtrId: zahtjevAtrId,
        formId: formId,
      }),
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};
export default connect(null, mapDispatchToProps)(OdobrenjeZahtjeva);
